export default __webpack_public_path__ + "static/media/add-new.0c206ca8.svg";